<template>
   <b-container fluid>
        <!-- btn-cadastrar novo cluster e modal -->
        <div v-if="temAcesso('Cluster','Salvar')" id="criarNovoCluster" @click="novoCluster" class="add-button"  
            v-b-popover.hover.top="'Adicionar novo cluster.'">
            <i class="fas fa-plus"></i>
        </div>
        <div v-else id="criarNovoCluster" disabled style="cursor:no-drop" class="add-button"  
            v-b-popover.hover.top="'Não possui permissões.'">
            <i class="fas fa-plus"></i>
        </div>

        <!-- MODAL CADASTRO DE CLUSTER -->
        <ModalCadastro :id="selectedId" :visible="visibleModalCadastro" />

        <!-- MODAL VISUALIZAR EMPRESAS POR FILTRO -->
        <ModalFiltroEmpresas name="table" :id="modalFiltroEmpresas.id" :filtros="modalFiltroEmpresas.filtros" />

        <el-tabs type="border-card">
            <el-tab-pane>
                <span slot="label"><i class="far fa-chart-bar"></i> Cluster </span>
                <container-card fixed id="cadastroDeCluster" icon="fa-sitemap" title="Clusters cadastrados">
                    <b-card>
                        <el-table
                            class="p-table"
                            v-loading="tableOptions.load"
                            :data="tableOptions.data"
                            :default-sort = "{ prop: 'createdAt', order: 'descending'}"
                            style="width: 100%"
                            stripe
                            border
                            size="mini">

                            <el-table-column prop="nome" label="Nome" align="left">
                              <template slot="header" slot-scope="scope">
                                Nome
                                <el-popover
                                ref="filterNome"
                                placement="bottom"
                                trigger="click"
                                width="400">
                                    <div style="margin-bottom:5px">
                                      <el-input class="input-filter" placeholder="Pesquisar nome" v-model="model.nome" size="mini"></el-input>
                                    </div>
                                    <el-button style="float:right" type="primary" size="mini" icon="el-icon-search" @click="setFilter">Filtrar</el-button>
                                    <el-button style="float:right; margin-right: 5px;" size="mini" icon="el-icon-brush" @click="clearFilter('nome')">Limpar</el-button>
                                    <el-button style="float:right" slot="reference" icon="fas fa-filter" size="mini" circle></el-button>
                                </el-popover>
                            </template>
                           </el-table-column>
                            <el-table-column
                                prop="descricao"
                                label="Descricao"
                                align="left">
                            </el-table-column>
                            
                            <el-table-column
                                prop="TipoDeCluster"
                                label="Tipo Cluster"
                                align="center"
                                width="130"
                                sortable>
                                <template slot-scope="scope" v-if="scope.row">
                                    <span v-if="scope.row.tipoDeCluster == 1" style="color:#76a3dc">Estático</span>
                                    <span v-if="scope.row.tipoDeCluster == 2" style="color:#62c774">Dinâmico</span>
                                </template>
                            </el-table-column>
                            <el-table-column
                                prop="empresas"
                                label="Empresas"
                                align="center"
                                width="170">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-button round icon="el-icon-view" @click="mostrarListaEmpresasModal(scope.row)" size="mini">Ver empresas</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="Ativo"
                                width="60"
                                align="center">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-tooltip v-if="scope.row.ativo" class="item" effect="dark" content="Status: Ativo" placement="top-start">
                                        <i class="fas fa-circle text-success"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="!scope.row.ativo" class="item" effect="dark" content="Status: Inativo" placement="top-start">
                                        <i class="fas fa-circle text-danger"></i>
                                    </el-tooltip>
                                </template>
                            </el-table-column>
                            <el-table-column
                                fixed="right"
                                label="Operações"
                                width="120">
                                <template slot-scope="scope" v-if="scope.row">
                                    <el-button v-if="temAcesso('Cluster','Salvar')" class="mr-1 cursor-pointer" icon="el-icon-edit-outline" circle size="mini" type="primary" @click.native="editarCluster(scope.row)"></el-button>
                                    <el-popover
                                        placement="top"
                                        width="250"
                                        :ref="`deletePop_${scope.$index}`">
                                        <p>Tem certeza que deseja deletar esse registro ?</p>
                                        <div style="text-align: right; margin: 0">
                                            <el-button type="secundary" size="mini" @click="deletarClusterOptOut(scope.$index)">Não</el-button>
                                            <el-button type="danger" size="mini" @click.native="deleteCluster(scope.$index, scope.row)">Sim</el-button>
                                        </div>
                                        <el-button v-if="temAcesso('Cluster','Deletar')" class="cursor-pointer" slot="reference" icon="el-icon-delete" circle size="mini" type="danger"></el-button>
                                    </el-popover>
                                </template>
                            </el-table-column>
                        </el-table><br>
                        <el-pagination
                          class="text-center"
                          background
                          layout="sizes, prev, pager, next"
                          @size-change="paginacaoSize"
                          @current-change="paginacaoCurrent"
                          :page-size="tableOptions.paginacao.pageSize"
                          :current-page.sync="tableOptions.paginacao.page"
                          :total="tableOptions.paginacao.total"
                          :page-sizes="[5, 10, 25, 50, 75, 100]">
                        </el-pagination>
                        
                        <el-button class="pull-right" size="small" type="success" icon="el-icon-download" @click="requestDownload">Exportar modelo</el-button> 
                        <el-button class="pull-right" size="small" type="primary" icon="el-icon-download" style="margin-right:5px" @click="gerarRelatorio" :loading="loadGerarRelatorio">Gerar relatório de Clusters</el-button>
                    </b-card>
                </container-card>
            </el-tab-pane>
        </el-tabs>
   </b-container>
</template>
<script>
import ContainerCard from '@/components/shared/ContainerCard'
import ModalCadastro from './modal/ModalCadastro'
import ModalFiltroEmpresas from '@/views/Cluster/modal/ModalFiltroEmpresas'
export default {
    name: 'Cluster',
    components: {
        ContainerCard,
        ModalCadastro,
        ModalFiltroEmpresas
    },
    data() {
        return {
            model: {
                nome: ''
            },
            windowHeight: window.innerHeight,
            visibleModalCadastro: false,
            selectedId: '',
            loadGerarRelatorio: false,
            modalFiltroEmpresas: {
                id: '',
                filtros: {}
            },
            tableOptions: {
                load: false,
                data: [],
                paginacao: {
                    page: 1,
                    pageSize: 25,
                    total: 10
                }
            }
        }
    },
    computed: {
        tableHeight() {
            return this.windowHeight - 277
        }
    },
    methods: {
        paginacaoCurrent(val){
          this.tableOptions.paginacao.page = val
          this.listarCluster();
        },
        paginacaoSize(val){
            this.tableOptions.paginacao.pageSize = val
            this.tableOptions.paginacao.page = 1
            this.listarCluster();
        },
        novoCluster(){
            this.selectedId = '';
            this.$bvModal.show('modal-cadastro-cluster')
        },
        editarCluster(row){
            this.selectedId = row._id;
            this.$bvModal.show('modal-cadastro-cluster')
        },
        deletarClusterOptOut(index,label, grupo){
            if(grupo){
                this.$refs['deletePop_grupo_'+index][0].showPopper = false
                return false
            }
            if(label){
                this.$refs['deletePop_'+(label ? label : '')+index][0].showPopper = false
                return false
            }

            this.$refs['deletePop_'+(label ? label : '')+index].showPopper = false
            
        },
        setFilter() {
            this.tableOptions.paginacao.page = 1
            this.listarCluster();
        },
        clearFilter(name) {
            this.model[name] = ''
            this.listarCluster();
        },
        async deleteCluster(index, row) {
            let response = await this.axios.delete(this.$urls.CLUSTER_DELETAR, { params: {
                id: row._id
            }});

            if(response.status !== 200) {
                return;
            }

            this.$message({
                type: 'success',
                message: 'Cluster deletado com sucesso !'
            });

            this.listarCluster();
            this.$refs['deletePop_'+index].showPopper = false
        },
        async listarCluster() {
            try {
                this.tableOptions.load = true;

                const response = await this.axios.get(this.$urls.CLUSTER_LISTAR_GRID, {
                    params: {
                        page: this.tableOptions.paginacao.page,
                        pageSize: this.tableOptions.paginacao.pageSize,
                        nome: this.model.nome
                    }
                });

                this.tableOptions.load = false
                
                if(response.status !== 200){
                    this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                    return;
                }
                
                this.tableOptions.data = response.data.clusters;
                this.tableOptions.paginacao.page = response.data.page;
                this.tableOptions.paginacao.total = response.data.total;
            } catch(err) {
                this.$notify.error({
                    title: 'Erro interno',
                    message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                    position:'top-left'
                });
            }finally {
                this.tableOptions.load = false
            }
        },
        async gerarRelatorio() {
            try {
                this.loadGerarRelatorio = true;

                const response = await this.axios.get(this.$urls.CLUSTER_GERAR_RELATORIO);

                this.loadGerarRelatorio = false
                
                if(response.status !== 200){
                    this.$message.error('Algum erro interno aconteceu, por favor consulte nosso suporte.');
                    return;
                }

                this.$notify({
                    type: "success",
                    title: 'Gerando Relatório',
                    dangerouslyUseHTMLString: true,
                    message: `Sua solicitação de relatório foi enviada, por favor verifique a tela de <a href="/#/relatorio" target="_blank">relatórios</a>`
                });
            } catch(err) {
                this.$notify.error({
                    title: 'Erro interno',
                    message: `Algum erro interno ocorreu, por favor entre em contato com nosso suporte`,
                    position:'top-left'
                });
                
            }finally {
                this.loadGerarRelatorio = false
            }
        },
        mostrarListaEmpresasModal(data) {
            // limpa antes do modal abrir
            this.modalFiltroEmpresas.id = ''
            this.modalFiltroEmpresas.filtros = {}
            if(!data) {
                return
            }
            if(data.tipoDeCluster == 2){
                this.modalFiltroEmpresas.filtros = data.filtros;
            }else{
                this.modalFiltroEmpresas.id = data._id;
            }

            this.$bvModal.show('modal-filtro-empresas-table')
        },
        callbackDownload(){
          this.tableOptions.load = false;
          this.$message.success('Download concluido.');
        },
        requestDownload(){
          this.tableOptions.load = true;
          this.$blob.getDownload(`${this.$urls.CLUSTER_DOWNLOAD_MODELO}`, this.callbackDownload) 
        }
    },
    mounted() {
        window.addEventListener('resize', () => {
            this.windowHeight = window.innerHeight
        });

        this.listarCluster();
    }
};
</script>
<style lang='scss' scoped>
    .add-button{
        width: 51px;
        padding: 14px 0;
        background: #343a40;
        color: #fff;
        text-align: center;
        border-radius: 50%;
        position: fixed;
        z-index: 10;
        cursor: pointer;
        bottom: 6px;
        margin-left: 3px;
    }
</style>